import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {CabBanner} from '/component/partial/CabBanner/CabBanner';
import {
  cabEligibleThroughDate,
  cabFqv,
  orderingEntityFirst30Days,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {withProps} from '/util/selector.util';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    cabBannerEligibleThroughDate: withCurrentUserCoachId(
      cabEligibleThroughDate,
    ),
    cabBannerFqv: withCurrentUserCoachId(cabFqv),
    orderingEntities: withCurrentUserCoachId(orderingEntityFirst30Days),
  }),
  null,
  (stateProps, _, ownProps) => {
    const {cabBannerEligibleThroughDate} = stateProps;
    const daysLeftForCAB = getDateUtilDefaultInstance().getDaysToToday(
      cabBannerEligibleThroughDate,
    );
    return {
      ...stateProps,
      ...ownProps,
      showCABBanner: daysLeftForCAB < 0,
      daysLeftForCAB: Math.abs(daysLeftForCAB),
    };
  },
)(CabBanner);
